/*
 * @Author: your name
 * @Date: 2020-06-18 15:06:22
 * @LastEditTime: 2020-06-18 15:57:21
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \leXiangH5线下落地页\src\main.js
 */ 
/* eslint-disable */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Meta from 'vue-meta';
const isDev = process.env.NODE_ENV === 'development' ? true : false;

Vue.prototype.$isDev = isDev;

Vue.use(Meta)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
